import "core-js/modules/es.array.map.js";
import { Box, Card, Flex, Heading, Link, Text } from '@applyboard/crystal-ui';
import { CircleOutlineIcon } from '@applyboard/ui-icons';
import { useApplicationCountByStatus } from "../../data/applicationsCount";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
function StepItem(_ref) {
  var text = _ref.text,
    demoUrl = _ref.demoUrl;
  return _jsxs(Flex, {
    gap: 2,
    align: "center",
    children: [_jsx(CircleOutlineIcon, {}), _jsx(Link, {
      as: "a",
      "aria-label": "Watch ".concat(text, " demo"),
      href: demoUrl,
      mode: "override_user_choice_and_open_in_new_tab",
      rel: "noopener",
      variant: "standalone",
      children: text
    })]
  });
}
export var DashboardEssentialSteps = function DashboardEssentialSteps(_ref2) {
  var isAdmin = _ref2.isAdmin;
  var _useApplicationCountB = useApplicationCountByStatus({
      readyForVisa: true
    }),
    applicationCount = _useApplicationCountB.applicationCount,
    isApplicationCountSuccess = _useApplicationCountB.isApplicationCountSuccess;
  var shouldShowSteps = isApplicationCountSuccess && applicationCount === 0;
  if (!isAdmin && !shouldShowSteps) {
    return null;
  }
  var tasksGroupA = [{
    text: 'Watch the training courses videos',
    demoUrl: 'https://app.storylane.io/demo/jygx9sjd61dn'
  }, {
    text: 'Add your first student',
    demoUrl: 'https://app.storylane.io/demo/kppai5jvugy6'
  }, {
    text: 'Create your first application',
    demoUrl: 'https://app.storylane.io/demo/b97n6oq0zate'
  }, {
    text: 'Complete payment for your application',
    demoUrl: 'https://app.storylane.io/demo/scfj5g1umxcf'
  }];
  var tasksGroupB = [{
    text: 'Review the application requirements',
    demoUrl: 'https://app.storylane.io/demo/kxuoaw6cnmsh'
  }, {
    text: 'Submit the application to school',
    demoUrl: 'https://app.storylane.io/demo/kxuoaw6cnmsh'
  }, {
    text: 'Track the application status',
    demoUrl: 'https://app.storylane.io/demo/kxuoaw6cnmsh'
  }, {
    text: 'Explore more schools and programs',
    demoUrl: 'https://app.storylane.io/demo/vqm11onswjir'
  }];
  return _jsxs(Flex, {
    direction: "column",
    gap: 2,
    children: [_jsx(Heading, {
      level: 2,
      variant: "headlineS",
      children: "Essential steps"
    }), _jsx(Text, {
      variant: "bodyM",
      intent: "secondary",
      contrast: "mid",
      children: "Complete these actions to unlock your full potential on ApplyBoard"
    }), _jsx(Box, {
      pt: 4,
      children: _jsx(Card, {
        children: _jsxs(Flex, {
          p: 2,
          direction: {
            xs: 'column',
            md: 'row'
          },
          justify: "start",
          gap: {
            xs: 4,
            md: 16
          },
          children: [_jsx(Flex, {
            gap: 4,
            direction: "column",
            children: tasksGroupA.map(function (task) {
              return _jsx(StepItem, {
                text: task.text,
                demoUrl: task.demoUrl
              }, task.text);
            })
          }), _jsx(Flex, {
            gap: 4,
            direction: "column",
            children: tasksGroupB.map(function (task) {
              return _jsx(StepItem, {
                text: task.text,
                demoUrl: task.demoUrl
              }, task.text);
            })
          })]
        })
      })
    })]
  });
};